import ConsultaBase from "../shared/ConsultaBase";
import { victex1CompresorConsultaConfig } from "../config/victex1CompresorConsulta";

const CVictex1Comp = () => {
  return <ConsultaBase config={victex1CompresorConsultaConfig} />;
};

export default CVictex1Comp;